import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
import { showNotification } from 'src/shared/components/Notification';
import LinearProgress from '@mui/material/LinearProgress';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import SubscriptionView from './SubscriptionView';


const ClientAdminScubscriptionDetailsIndex = () => {
  useEffect(() => {
    getSubscriptionInformation();
  }, [])
  const [loading, setLoading] = useState(false);
  const [reactTableData, setReactTableData] = useState([]);
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const getSubscriptionInformation = async () => {
    try {
      setLoading(true);
      const response = await PndRestApi.GetSubscriptionDetailsByCustomerId();

      if (response.status === 200 && response.data.status === 200) {
        const data = response.data.data;

        // Convert object to array if necessary
        const arrayData = Array.isArray(data) ? data : [data];

        setReactTableData({ tableHeaderData: columns, tableRowsData: arrayData });
      } else if (response.status === 200 && response.data.status === 204) {
        setNoRecordFound(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response?.data?.status}`,
          `Message: ${response?.data?.message}`
        );
      }
    } catch (error) {
      console.log("Error in getSubscriptionInformation", error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        `Message: Something went wrong. Please try again later.`
      );
    } finally {
      setLoading(false);
    }
  };


  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: (row, i) => i + 1, // Or just use Cell below for more control
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 45,
        Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
      },
      {
        Header: 'Subscription Start Date',
        accessor: 'subscriptionStartDate',
        disableGlobalFilter: false,
      },
      {
        Header: 'Subscription End Date',
        accessor: 'subscriptionEndDate',
        disableGlobalFilter: false,
      },
      {
        Header: 'Allowed Device Count',
        accessor: 'maxDeviceCount',
        disableGlobalFilter: true,
      },
      // {
      //   Header: 'SMS Count',
      //   accessor: 'maxSmsCount',
      //   disableGlobalFilter: true,
      // },
      {
        Header: 'Hub Count',
        accessor: 'maxHubCount',
        disableGlobalFilter: true,
      },

      {
        Header: 'Manager Count',
        accessor: 'maxHubManagerCount',
        disableGlobalFilter: true,
      },
      {
        Header: 'Operator Count',
        accessor: 'maxHubOperatorCount',
        disableGlobalFilter: true,
      },

    ],
    [],
  );
  return (
    <Container>

      {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && <SubscriptionView reactTableData={reactTableData} />}
      {loading && <LinearProgress color="primary" />} {/* Display progress bar while loading */}
      {isNoRecordFound && <SubscriptionView isNoRecordFound={isNoRecordFound} />}
    </Container>
  );
};

export default ClientAdminScubscriptionDetailsIndex;
